import { Maybe } from '@aibees/shared/definition';
import { classnames } from '@aibees/shared/utils';
import { Typography } from '@mui/material';
import { isArray, isNil } from 'lodash-es';
import { memo, useMemo } from 'react';
import { DropDownValueMultiple } from '../drop-down-value-multiple';
import { DropDownValueSingle } from '../drop-down-value-single';
import * as Styled from './styles';
import * as SX from './sx';
import type { DropDownValueProps as Props } from './types';

export const DropDownValue = memo(
  ({
    className,
    value,
    placeholder,
    options,
    multiple,
    renderValue,
  }: Props) => {
    const v: Maybe<any[]> = useMemo(() => {
      // if (value === '') return undefined;
      return isArray(value) ? value : [value].filter((x) => !isNil(x));
    }, [value]);
    const selectedOptions = useMemo(() => {
      return options.filter((x) => v?.includes(x.value ?? x.key));
    }, [v, options]);

    if (
      (!multiple && isNil(value)) ||
      // value === '' ||
      (multiple && !value?.length)
    )
      return (
        <Typography variant="body4" color="text.disabled">
          {placeholder}
        </Typography>
      );

    return (
      <Styled.Wrapper
        className={classnames('DropDownValue', className)}
        sx={SX.root}
      >
        {multiple ? (
          <DropDownValueMultiple selectedOptions={selectedOptions} />
        ) : (
          <DropDownValueSingle selectedOptions={selectedOptions} />
        )}
      </Styled.Wrapper>
    );
  }
);

DropDownValue.displayName = 'DropDownValue';
